// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-top {
  background-color: #ffffff;
  position: fixed;
  top: 0;
  left: 70px;
  width: calc(100% - 70px);
  z-index: 1000;
  height: 40px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.navbar-left {
  font-weight: bold;
  font-size: 24px;
  font-family: "Maersk Headline";
  color: var(--mp-tree-item-current-color);
}

.navbar-center {
  font-weight: lighter;
  text-align: center;
}

.navbar-right {
  display: flex;
  align-items: center;
}

.Dropdown:active {
  background-color: var(--mp-view-bar-current-color);
  color: white;
}

.navbar-top {
  transition: margin-left 0.3s ease;
}
.navbar-top.with-sidebar .navbar-left.mds {
  margin-left: 130px;
}
.navbar-top .navbar-left.mds {
  transition: margin-left 0.3s ease;
  margin-left: 0;
}`, "",{"version":3,"sources":["webpack://./src/Layouts/Navbar/AppNavbar.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,eAAA;EACA,MAAA;EACA,UAAA;EACA,wBAAA;EACA,aAAA;EACA,YAAA;EACC,wCAAA;AACL;;AAGE;EACE,iBAAA;EACA,eAAA;EACA,8BAAA;EACA,wCAAA;AAAJ;;AAEE;EACE,oBAAA;EACA,kBAAA;AACJ;;AACE;EACE,aAAA;EACA,mBAAA;AAEJ;;AACE;EACI,kDAAA;EACA,YAAA;AAEN;;AACE;EACE,iCAAA;AAEJ;AACM;EACE,kBAAA;AACR;AAGI;EACE,iCAAA;EACA,cAAA;AADN","sourcesContent":[".navbar-top{\n    background-color: #ffffff;\n    position: fixed;\n    top:0;\n    left: 70px;\n    width: calc(100% - 70px);\n    z-index: 1000;\n    height: 40px;\n     box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    \n  }\n  \n  .navbar-left{\n    font-weight: bold;\n    font-size: 24px;\n    font-family: 'Maersk Headline';\n    color: var( --mp-tree-item-current-color);\n  }\n  .navbar-center{\n    font-weight: lighter;\n    text-align: center;\n  }\n  .navbar-right{\n    display: flex;\n    align-items: center;\n  }\n  .Dropdown {\n  &:active {\n      background-color: var(--mp-view-bar-current-color); \n      color: white;\n    }\n  }\n  .navbar-top {\n    transition: margin-left 0.3s ease;\n  \n    &.with-sidebar {\n      .navbar-left.mds {\n        margin-left: 130px; \n      }\n    }\n  \n    .navbar-left.mds {\n      transition: margin-left 0.3s ease;\n      margin-left: 0; \n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
